module.exports = function getResource(label, vars = []) {
    let resources = {
        categories: 'Categories',
        category: 'Category'
    };
    return resources[label];
};
